// Copyright (C) 2022 Intel Corporation
//
// SPDX-License-Identifier: MIT
import { ActionUnion, createAction, ThunkAction } from 'utils/redux';
import { getCore } from 'cvat-core-wrapper';

const core = getCore();

export enum SampleActionTypes {
    GET_SAMPLE = 'GET_SAMPLE',
    GET_SAMPLE_SUCCESS = 'GET_SAMPLE_SUCCESS',
    GET_SAMPLE_FAILED = 'GET_SAMPLE_FAILED',
}

const sampleActions = {
    getSample: () => createAction(SampleActionTypes.GET_SAMPLE),
    getSampleSuccess: (sample: any) => createAction(SampleActionTypes.GET_SAMPLE_SUCCESS, { sample }),
    getSampleFailed: (error: any) => createAction(SampleActionTypes.GET_SAMPLE_FAILED, { error }),
};

export type SampleActions = ActionUnion<typeof sampleActions>;

export const getSampleAsync = (imageName: string): ThunkAction => async (dispatch): Promise<void> => {
    dispatch(sampleActions.getSample());

    try {
        const sampleId = imageName.includes('_') ?
            imageName.substring(imageName.indexOf('_') + 1, imageName.indexOf('.jpg')) :
            imageName.substring(0, imageName.indexOf('.jpg'));

        const sample = await core.server.sample(sampleId);

        dispatch(sampleActions.getSampleSuccess(sample));
    } catch (error) {
        dispatch(sampleActions.getSampleFailed(error));
    }
};
